<button class="btn-sm hover:bg-gl-blue-hover bg-gl-blue text-white h-fit px-1" ngxTippy data-tippy-content="Reporte"
    *ngIf="isModal && showBottom" data-tippy-singleton (click)="openModal(); showFilter = true">
    <div class="w-6 h-6 grid place-content-center">
        <i class="fa-duotone fa-print"
            style="font-size: 1rem; --fa-primary-opacity: 0.4; --fa-secondary-opacity: 1;"></i>
    </div>
</button>
<button [id]="'botonShowReporte_'+instance" type="hidden"
    (click)="openModal(); checkAndSelectReport(); showFilter = true"></button>

<ng-template #bodyAll>
    <div>
        <div class="grid grid-cols-3 gap-4 m-3" *ngIf="reports.length > 1">
            <div class="report-option shadow-md rounded px-4 py-2 w-fit cursor-pointer flex items-center justify-center flex-col min-w-[8rem] max-w-[8rem]"
                ngxTippy [ngxTippy]="item.title" data-tippy-singleton
                [ngClass]="{'bg-gl-blue text-white': reportSelected?.title == item.title, 'bg-white': reportSelected?.title != item.title }"
                *ngFor="let item of reports" (click)="selectReport(item)">
                <i class="fa-duotone fa-print mr-2"
                    style="font-size: 1rem; --fa-primary-opacity: 0.4; --fa-secondary-opacity: 1;">
                </i>
                <strong>
                    {{ item.title }}
                </strong>
            </div>
        </div>
        <div class="grid grid-cols-3 gap-4 m-3" *ngIf="!reports[0]">
            <!-- Sin reportes -->
            <div
                class="report-option shadow-md rounded px-4 py-2 w-fit cursor-pointer flex items-center justify-center flex-col min-w-[8rem] max-w-[8rem]">
                <strong>
                    No hay reportes disponibles
                </strong>
            </div>

        </div>

        <div class="px-5 py-3 border-t bg-pearl border-slate-200" *ngIf="reportSelected?.filter?.length">
            <div class="flex justify-between items-center">
                <div class="font-semibold text-primary-100">Filtros</div>
            </div>
            <div class="grid grid-cols-2 gap-4 mt-3">
                <div class="flex flex-col" *ngFor="let item of reportSelected?.filter; let i = index">
                    <label class="text-slate-400 text-sm">{{item.name}}</label>
                    <input class="form-input w-full" [(ngModel)]="item.value" [type]="'text'"
                        *ngIf="item.type == 'date'" [id]="item.id" [required]="item.required" [spellcheck]="true" />
                    <div class="form-switch w-full" *ngIf="item.type == 'checkbox'">
                        <input type="checkbox" id="name-toggle-{{i}}" (ngModelChange)="changeCheckBox($event,i)"
                            [(ngModel)]="item.value" [required]="item.required" class="sr-only mt-1">
                        <label class="bg-slate-400" for="name-toggle-{{i}}">
                            <span class="bg-white shadow-sm"></span>
                            <span class="sr-only">
                                {{item.name}}
                            </span>
                        </label>
                    </div>

                </div>
            </div>
        </div>
        <div class="py-5 px-4 border-t bg-pearl border-slate-200 sticky bottom-0">
            <div class="flex flex-wrap justify-end space-x-2">
                <button
                    class="btn-sm hover:bg-gl-blue-hover bg-gl-blue text-white 
                 disabled:border-slate-200 disabled:bg-slate-100 disabled:text-slate-400 disabled:cursor-not-allowed shadow-none close-overlay-directive"
                    [disabled]="!isValid()" (click)="getReport(functionSelectorOverlay)">Aceptar</button>
            </div>
        </div>
    </div>
</ng-template>

<!-- Uso de bodyReports dentro de un modal (o cualquier otro lugar) con ngTemplateOutlet -->
<ng-container *ngIf="isModal">
    <ng-template appModalOverlay #functionSelectorOverlay="appModalOverlay" *ngIf="isModal" [closeOnEscape]="false"
        [panelClass]="'custom-overlay-pane-class'" [closeBackdropClick]="false">
        <div class="bg-white rounded shadow-lg overflow-hidden w-[32rem] max-w-[90vw] max-h-[90dvh] m-auto flex flex-col"
            *ngIf="showFilter ">
            <div class="px-5 py-3 border-b bg-white border-slate-200 relative top-0">
                <div class="flex justify-between items-center">
                    <div class="font-semibold text-primary-100" *ngIf="reports.length > 1 || reports.length == 0">
                        Selecciona el reporte a descargar</div>
                    <div class="font-semibold text-primary-100" *ngIf="reports.length == 1">Descargar reporte
                        <strong>
                            {{reports[0].title}}
                        </strong>
                    </div>
                    <button class="text-slate-400 hover:text-slate-500 close-overlay-directive"
                        (click)="closeModal(); showFilter = false">
                        <div class="sr-only">Cerrar</div>
                        <svg class="w-4 h-4 fill-current">
                            <path
                                d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z">
                            </path>
                        </svg>
                    </button>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="bodyAll"></ng-container>
        </div>
    </ng-template>
</ng-container>

<!-- Uso de bodyReports fuera de un modal -->
<ng-container *ngIf="!isModal">
    <ng-container *ngTemplateOutlet="bodyAll"></ng-container>
</ng-container>